/**
 * Bounded Context: Session — Pinia store
 */

import { defineStore } from "pinia";
import { ref } from "vue";
import type { FocusItem, Thread } from "./types";

const MAX_FOCUS = 5;

export const useSessionStore = defineStore("session", () => {
  const currentThread = ref<Thread | null>(null);

  function openThread(thread: Thread): void {
    currentThread.value = thread;
  }

  function closeThread(): void {
    currentThread.value = null;
  }

  /**
   * Adiciona item de foco. Se exceder MAX_FOCUS, descarta o mais antigo (FIFO).
   * Constitucional: working memory cap (CL-12) — nunca crescer sem limite.
   */
  function pushFocus(item: FocusItem): void {
    const thread = currentThread.value;
    if (!thread) return;
    const next = [...thread.focus, item];
    const trimmed = next.length > MAX_FOCUS ? next.slice(next.length - MAX_FOCUS) : next;
    currentThread.value = { ...thread, focus: trimmed };
  }

  return {
    currentThread,
    maxFocus: MAX_FOCUS,
    openThread,
    closeThread,
    pushFocus,
  };
});
